import { render } from "./Selection.vue?vue&type=template&id=01143852&scoped=true"
import script from "./Selection.vue?vue&type=script&lang=js"
export * from "./Selection.vue?vue&type=script&lang=js"

import "./Selection.vue?vue&type=style&index=0&id=01143852&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01143852"]])

export default __exports__